// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__11s0l","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3hzg9"};